import SUBUSER_PERMISSION_SLUGS from '@/constants/authorization/subuser-permission-slugs'

export default [
  {
    title: 'navigation.crm',
    svgIcon: 'icon-crm',
    children: [
      {
        title: 'client.customers-list',
        svgIcon: 'icon-customers-list',
        route: 'admin:customers',
        permission: SUBUSER_PERMISSION_SLUGS.CLIENTS_VIEW,
      },
      {
        title: 'client.customers-statistics',
        svgIcon: 'icon-customers-statistics',
        route: 'admin:customers:statistics',
        permission: SUBUSER_PERMISSION_SLUGS.CLIENTS_VIEW,
      },
      {
        title: 'client.items-insight',
        svgIcon: 'icon-items-insight',
        route: 'admin:customers:items-insight',
        permission: SUBUSER_PERMISSION_SLUGS.CLIENTS_VIEW,
      },
      {
        title: 'self-compare.self-compare',
        svgIcon: 'self-compare',
        route: 'admin:reports:self-compare',
        permission: SUBUSER_PERMISSION_SLUGS.REPORTS_STATISTICS_VIEW,
      },
      {
        title: 'client.customer_reviews',
        svgIcon: 'reviews-icon',
        route: 'admin:customers:reviews',
        permission: SUBUSER_PERMISSION_SLUGS.REVIEWS_VIEW,
      },
    ],
  },

]
